import { forwardRef } from 'react';
import { theme } from '@frontend/theme';
import { NakedButton } from '@frontend/design-system';
import { floatingStyles } from './floating-styles';

type Props = {
  children?: React.ReactNode;
  onClick?: () => void;
  variant?: 'primary' | 'secondary';
};

// TODO: Add a tracking id prop
export const FloatingButton = forwardRef<HTMLButtonElement, Props>(
  ({ children, onClick, variant = 'secondary', ...rest }, ref) => {
    return (
      <NakedButton
        css={[
          floatingStyles,
          variant === 'primary'
            ? {
                background: theme.colors.primary50,
                color: theme.colors.white,
                fontWeight: theme.font.weight.bold,
                '.floating-toolbar.right-top &, .floating-toolbar.right-center &, .floating-toolbar.right-bottom &': {
                  border: `solid 1px ${theme.colors.primary50}`,
                  borderLeft: 0,
                },
                '.floating-toolbar.left-top &, .floating-toolbar.left-center &, .floating-toolbar.left-bottom &': {
                  border: `solid 1px ${theme.colors.primary50}`,
                  borderRight: 0,
                },
                '&:hover, &:focus': {
                  background: theme.colors.primary60,
                  borderColor: theme.colors.primary60,
                  outline: 'none',
                },
              }
            : {
                background: theme.colors.white,
                boxShadow: theme.shadows.light,
                color: theme.colors.neutral70,
                fontWeight: theme.font.weight.bold,
                '.floating-toolbar.right-top &, .floating-toolbar.right-center &, .floating-toolbar.right-bottom &': {
                  border: `solid 1px ${theme.colors.neutral30}`,
                  borderLeft: 0,
                  boxShadow: 'none',
                },
                '.floating-toolbar.left-top &, .floating-toolbar.left-center &, .floating-toolbar.left-bottom &': {
                  border: `solid 1px ${theme.colors.neutral30}`,
                  borderRight: 0,
                  boxShadow: 'none',
                },
                '&:hover, &:focus': {
                  background: theme.colors.neutral5,
                  boxShadow: theme.shadows.floating,
                  color: theme.colors.black,
                  outline: 'none',
                },
              },
        ]}
        onClick={(e) => {
          e.stopPropagation();
          onClick?.();
        }}
        ref={ref}
        {...rest}
      >
        {children}
      </NakedButton>
    );
  }
);

FloatingButton.displayName = 'FloatingButton';
